var _rect, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCarlinkApi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 2,
    fill: "#27AB27"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.975 13.3276C11.825 12.8532 14 10.3336 14 7.29654C14 3.92133 11.3137 1.18518 8 1.18518C4.68629 1.18518 2 3.92133 2 7.29654C2 10.4011 4.27277 12.965 7.21604 13.3562L8.08709 14.8338L8.975 13.3276Z",
    fill: "#FDFFFE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4322_34062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.48519 5.19791V6.43345C5.06692 6.48602 4.73738 6.27572 4.68669 5.94712V5.19791C4.64866 4.79045 5.28239 3.92294 5.9288 3.92294H10.0227C10.4916 3.92294 11.2141 4.51442 11.2521 5.19791V5.94712C11.2394 6.27572 10.9099 6.43345 10.4536 6.43345V5.19791C10.4612 5.05344 10.4268 5.01132 10.2888 5.0139H5.63728C5.51466 5.01433 5.48092 5.05396 5.48519 5.19791Z",
    fill: "#27AB27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.21777 5.06649C4.32914 4.96553 4.39561 4.96111 4.52196 5.06649V5.90771C4.40821 5.97789 4.34161 5.9798 4.21777 5.90771V5.06649Z",
    fill: "#27AB27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3916 5.06649C11.503 4.96553 11.5694 4.96111 11.6958 5.06649V5.90771C11.582 5.97789 11.5154 5.9798 11.3916 5.90771V5.06649Z",
    fill: "#27AB27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.77539 8.01175C4.77539 7.45946 5.22311 7.01175 5.77539 7.01175H10.138C10.6903 7.01175 11.138 7.45946 11.138 8.01175V9.27146C11.138 9.75948 10.7884 10.1659 10.326 10.2538C10.3265 10.264 10.3268 10.2744 10.3268 10.2847C10.3268 10.6114 10.0714 10.8762 9.75644 10.8762C9.44144 10.8762 9.18609 10.6114 9.18609 10.2847C9.18609 10.2803 9.18613 10.2759 9.18623 10.2715H6.72719L6.72733 10.2847C6.72733 10.6114 6.47197 10.8762 6.15697 10.8762C5.84197 10.8762 5.58662 10.6114 5.58662 10.2847C5.58662 10.2744 5.58688 10.264 5.58738 10.2538C5.12497 10.1659 4.77539 9.75948 4.77539 9.27146V8.01175Z",
    fill: "#27AB27"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.14404,
    y: 4.22528,
    width: 3.59958,
    height: 0.6572,
    rx: 0.3286,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.14427,
    cy: 8.56275,
    rx: 0.456285,
    ry: 0.473184,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.74388,
    cy: 8.56275,
    rx: 0.456285,
    ry: 0.473184,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4322_34062"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.57143,
    height: 7.11111,
    fill: "white",
    transform: "translate(3.71436 3.85184)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCarlinkApi);
export default __webpack_public_path__ + "static/media/ic-carlink-api.ea5e1d707f0dbb8179948d9972e3758f.svg";
export { ForwardRef as ReactComponent };